import { matchElement } from '@jusbrasil-web/docview/core'
import { buildCanonicalSERPUrl } from '@jusbrasil-web/shared-search-canonical-url'
import { HTMLElement, parse, TextNode } from 'node-html-parser'
import { renderToString } from 'react-dom/server'

import { AttachmentImage } from '../../components'
import { escape } from './escape'

const STARTS_WITH_ACAO_REGEX = /^A[CÇ][AÃ]O\b/i
const ATTACHMENT_IMAGE_CLASS = 'attachment-image'

export class MotionTextProcessor {
  originalHtml: string
  lawsuitTheme: string | null | undefined
  parsedHtml: HTMLElement

  constructor(html: string, lawsuitTheme?: string | null) {
    this.originalHtml = html
    this.lawsuitTheme = lawsuitTheme
    this.parsedHtml = parse(html)
  }

  buildLawsuitThemeSerpLink() {
    if (!this.lawsuitTheme || !STARTS_WITH_ACAO_REGEX.test(this.lawsuitTheme)) {
      return
    }

    const escapePattern = /[-/\\^$*+?.()|[\]{}]/gi
    const escapedInput = this.lawsuitTheme.replace(escapePattern, '\\$&')
    const re = new RegExp(escapedInput, 'i')
    if (!re.test(this.parsedHtml.toString())) {
      return
    }

    const matchingElement = matchElement(this.parsedHtml, re)
    if (matchingElement) {
      const motionThemeSerpUrl = buildCanonicalSERPUrl({
        path: '/pecas/busca',
        queryParams: { q: this.lawsuitTheme },
      })
      const link = `<a href="${motionThemeSerpUrl}" class="lawsuit-theme-link">${escape(
        this.lawsuitTheme
      )}</a>`
      matchingElement.textContent = matchingElement.textContent.replace(re, link)
    }
  }

  private getNextElementSibling(element: HTMLElement) {
    if (
      element.nextSibling === element.nextElementSibling ||
      // Ignore empty text nodes
      (element.nextSibling instanceof TextNode && element.nextSibling.textContent.trim() === '')
    ) {
      return element.nextElementSibling
    }
    return null
  }

  processImages() {
    const attachmentImageRendered = renderToString(<AttachmentImage />)

    this.parsedHtml.querySelectorAll(`.${ATTACHMENT_IMAGE_CLASS}`).forEach((image) => {
      const nextElement = this.getNextElementSibling(image)
      if (nextElement?.classList.contains(ATTACHMENT_IMAGE_CLASS)) {
        image.remove()
      } else {
        image.replaceWith(attachmentImageRendered)
      }
    })
  }

  processedText() {
    this.buildLawsuitThemeSerpLink()
    this.processImages()

    return this.parsedHtml.toString()
  }
}
